// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from '@/store'
import '@/utils/vant.js'
import $ from 'jquery'
import FastClick from 'fastclick'
import Router from 'vue-router'
import 'lib-flexible'
// 全局引入 Reset-css
import 'reset-css'
import '@/assets/common.css'
import { formatDate } from '@/utils/formatDate'
import { asyncCall } from '@/utils/JBFAPPbridge'
import { commonUtils } from '@/mixin/commonUtils'
import './icons'
import noData from '@/components/noData'
import scrollToTop from './components/scrollToTop.vue'
// 解决移动端点击延迟200ms的问题
if ('addEventListener' in document) {
  document.addEventListener('DOMContentLoaded', function () {
    FastClick.attach(document.body)
  }, false)
}
FastClick.prototype.focus = function (targetElement) {
  var length
  var deviceIsWindowsPhone = navigator.userAgent.indexOf('Windows Phone') >= 0
  var deviceIsIOS = /iP(ad|hone|od)/.test(navigator.userAgent) && !deviceIsWindowsPhone
  // 兼容处理:在iOS7中，有一些元素（如date、datetime、month等）在setSelectionRange会出现TypeError
  // 这是因为这些元素并没有selectionStart和selectionEnd的整型数字属性，所以一旦引用就会报错，因此排除这些属性才使用setSelectionRange方法
  if (deviceIsIOS && targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 && targetElement.type !== 'time' && targetElement.type !== 'month' && targetElement.type !== 'email') {
    length = targetElement.value.length
    targetElement.setSelectionRange(length, length)// 修复bug ios 11.3不弹出键盘，这里加上聚焦代码，让其强制聚焦弹出键盘
    targetElement.focus()
  } else {
    targetElement.focus()
  }
}
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.config.productionTip = false
Vue.prototype.$serverconfig = window.serverconfig
Vue.prototype.$formatDate = formatDate

Vue.prototype.$asyncCall = asyncCall

Vue.component('my-no-data', noData)
Vue.component('scroll-to-top', scrollToTop)
var u = navigator.userAgent
var terminal = ''
if (u.indexOf('Android') > -1 || u.indexOf('Adr') > -1) {
  terminal = 'Android'
  // eslint-disable-next-line no-extra-boolean-cast
} else if (!!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
  terminal = 'IOS'
}
Vue.prototype.$terminal = terminal

Vue.prototype.modifiedDateFormatter = (row, col, cellValue) => {
  if (cellValue) {
    return formatDate(new Date(cellValue), 'time')
  }
  return cellValue
}
Vue.filter('dateFormat', function(value, format) {
  if (!value) return ''
  return formatDate(new Date(value), 'date')
})
Vue.prototype.$formatDate = formatDate
Vue.filter('timeFormat', function(value, format) {
  if (!value) return ''
  return formatDate(new Date(value), 'time')
})
Vue.mixin(commonUtils)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js